module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title,
      "listable": ""
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          on: {
            "click": _vm.ok
          }
        }, [_vm._v("ОК")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
          on: {
            "click": function($event) {
              return _vm.addItem()
            }
          }
        }, [_vm._v("Добавить")])]
      },
      proxy: true
    }])
  }, [_c('v-list', {
    attrs: {
      "one-line": "",
      "dense": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content'), _vm._v(" "), _c('v-list-tile-action', [_c('div', [_c('v-icon', {
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('v-icon', {
    on: {
      "click": _vm.checkAll
    }
  }, [_vm._v("check_box")]), _vm._v(" "), _c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.removeMode),
      expression: "removeMode"
    }],
    on: {
      "click": _vm.minusAll
    }
  }, [_vm._v("indeterminate_check_box")])], 1)])], 1), _vm._v(" "), _vm._l((this.items), function(item) {
    return [_c('v-list-tile', {
      key: item.id,
      on: {
        "click": function($event) {
          return _vm.select(item.id)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('span', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.open(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.check(item.id)),
        expression: "check(item.id)"
      }]
    }, [_vm._v("check_box")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.check(item.id) && !_vm.check(-1 * item.id)),
        expression: "!check(item.id) && !check(-1 * item.id)"
      }]
    }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.check(-1 * item.id)),
        expression: "check(-1 * item.id)"
      }]
    }, [_vm._v("indeterminate_check_box")])], 1)], 1)]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ea40e7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/favorite/TagSelector.vue
// module id = 872
// module chunks = 1